/* @flow */

import * as React from 'react';

import FullWidthTemplate from './FullWidthTemplate';
import { MAX_NO_SIDEBAR_GRID_WIDTH } from '../../style/token/grid';

type Props = {
  Switch: React.ComponentType<any>,
};

const StretchedWidthTemplate = ({ Switch }: Props): React.Node => (
  <FullWidthTemplate
    contentMaxWidth={MAX_NO_SIDEBAR_GRID_WIDTH}
    Switch={Switch}
  />
);

export default React.memo<Props>(StretchedWidthTemplate);
